import formatPrice from 'Utils/formatPrice'

const ZERO_CENTS = /\.00$/

export default function formatPlanPrice(price) {
  const formatted = formatPrice(price)

  return typeof formatted === 'string' ? formatted.replace(ZERO_CENTS, '') : formatted
}
